<template>
  <section
    class="w-full bg-neutral-700 dark:bg-neutral-800 text-white overflow-hidden relative"
    :class="{ flex: expand }"
  >
    <ContainerBasic class="relative">
      <img
        v-if="!centered && !expanded"
        class="z-[1] object-fill w-[300px] lg:w-[200px] xl:w-[340px] max-w-none absolute top-1/2 -translate-y-[50%] opacity-[0.15] right-0 dark:opacity-[0.35]"
        src="~/assets/images/logomark-black.svg"
        alt=""
      />
      <div
        class="relative z-[2]"
        :class="{
          'flex flex-col items-center justify-center': expand,
          'flex-1': !centered,
          'text-center': centered,
          'py-8 lg:py-16 xl:py-32 2xl:px-0': !expanded,
          'py-14 lg:py-24 xl:py-48 2xl:px-0': expanded,
        }"
      >
        <a
          v-if="showNew"
          href="#"
          class="inline-flex items-center justify-between px-1 py-1 pr-4 text-sm text-gray-700 bg-neutral-100 rounded-full mb-7 dark:bg-neutral-800 dark:text-white hover:bg-neutral-200 dark:hover:bg-neutral-700"
          role="alert"
        >
          <span class="text-xs bg-primary-600 rounded-full dark:text-white px-4 py-1.5 mr-3"
            >New</span
          >
          <span class="text-sm font-medium"
            >64 Analytics is under development! Check back soon</span
          >
          <svg
            class="w-5 h-5 ml-2"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </a>
        <h1
          class="mb-0 text-4xl font-extrabold leading-none tracking-tight dark:text-white md:text-5xl lg:text-6xl"
          :class="{
            'w-full': !centered,
          }"
        >
          <slot></slot>
        </h1>
        <p
          v-if="$slots.subHeading"
          class="mb-8 text-lg font-normal dark:text-gray-200 lg:text-xl mt-4"
          :class="{
            'w-full': !centered,
            'sm:px-16 xl:px-48': centered,
          }"
        >
          <slot name="subHeading"></slot>
        </p>
        <p
          v-if="comingSoon"
          class="mb-8 text-lg font-bold dark:text-gray-200 lg:text-xl"
          :class="{
            'w-full': !centered,
            'sm:px-16 xl:px-48': centered,
          }"
        >
          <slot name="comingSoon">Coming Soon</slot>
        </p>
        <slot name="body" />
        <!-- <div
          class="flex flex-col mb-8 space-y-4 lg:mb-16 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-4"
        >
          <a
            href="#"
            class="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900"
          >
            Learn more
            <svg
              class="w-5 h-5 ml-2 -mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </a>
          <a
            href="#"
            class="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white border border-gray-300 rounded-lg hover:bg-neutral-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-neutral-700 dark:focus:ring-gray-800"
          >
            Get Started
          </a>
        </div> -->
      </div>
    </ContainerBasic>
  </section>
</template>

<script lang="ts" setup>
type MyProps = {
  showNew?: boolean;
  expand?: boolean;
  centered?: boolean;
  expanded?: boolean;
  comingSoon?: boolean;
};
const props = withDefaults(defineProps<MyProps>(), {
  showNew: false,
  expand: true,
  centered: false,
  expanded: false,
  comingSoon: false,
});
</script>
